module.exports = __webpack_public_path__ + "img/SoulPay_Tag_Neg.f89d943e.png";